// /*
//     * Created on Wed Oct 11 2023 4:46:23 PM
//     *
//     * ***************************************************************************************
//     * Copyright (c) AVPS Technologies Inc 2023 
//     *
//     * All Rights Reserved
//     * Unpublished rights are reserved under the copyright laws of the United States.
//     * The software contained in this media is proprietary to and embodies confidential
//     * the technology of AVPS Technologies Inc. Possession, use, duplication or
//     * dissemination of the software and media is authorized only pursuant to a valid
//     * written license from AVPS Technologies Inc.
//     *
//     * The above copyright notice and this permission notice shall be included in
//     * all copies or substantial portions of the Software.
//     *
//     * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
//     * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
//     * 252.227-7013 or in FAR 52.227-19, as applicable.
//     ****************************************************************************************
//  */
// import { CalendarDays } from 'lucide-react';
// import moment from 'moment-timezone';
// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router';
// import { findDiscountsByCriteria, findEligibleDiscounts } from '../../../../api/action/discount';
// import { saveScheduledProduct } from '../../../../api/action/schedule';
// import { useCart } from '../../../../context/CartContext';
// import { addToShoppingCart } from '../../../products/ProductToCart';
// import { bookingTypes, mockOffers } from './BookingConfigs';
// import { BookingTypeCard, CalendarView, DurationControl, TimeSlotPicker } from './BookingControls';
// import { LoginDialog, OffersSection, OrderSummary } from './BookingDisplay';

// export const MeetingScheduler = () => {
//   const location = useLocation();
//   const { product } = location.state || {};
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { addToCart } = useCart();

//   const [bookingType, setBookingType] = useState('hourly');
//   const [duration, setDuration] = useState(2);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [selectedTime, setSelectedTime] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const [currentMonth, setCurrentMonth] = useState(moment());
//   const [showLoginDialog, setShowLoginDialog] = useState(false);
//   const [isProcessingPending, setIsProcessingPending] = useState(false);
//   const [eligibleDiscounts, setEligibleDiscounts] = useState([]);
//   const [selectedDiscount, setSelectedDiscount] = useState(null);
//   const [isFetchingDiscounts, setIsFetchingDiscounts] = useState(false);
//   const [hasPendingBooking, setHasPendingBooking] = useState(false);
//   const [isCheckingPending, setIsCheckingPending] = useState(true);
//   const [showBookingInterface, setShowBookingInterface] = useState(false);
//   const [isProcessingGuestLogin, setIsProcessingGuestLogin] = useState(false);

//   const companyId = useSelector((state) => state.companyReducer.company.primaryId);
//   const userAccount = useSelector((state) => state?.auth?.data);
//   const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);
//   const durationType = sessionStorage.getItem('selectedDuration') || '';

//   const getFilteredBookingTypes = () => {
//     switch (durationType) {
//       case 'HOUR':
//         return bookingTypes;
//       case 'DAY':
//         return bookingTypes.filter(type => type.id !== 'hourly');
//       case 'WEEK':
//         return bookingTypes.filter(type => type.id !== 'hourly' && type.id !== 'daily');
//       case 'MONTH':
//         return bookingTypes.filter(type => type.id === 'monthly');
//       default:
//         return bookingTypes;
//     }
//   };

//   const filteredBookingTypes = getFilteredBookingTypes();
//   const currentBookingType = filteredBookingTypes.find(type => type.id === bookingType) || filteredBookingTypes[0];

//   useEffect(() => {
//     const fetchDiscounts = async () => {
//       if (!companyId) return;

//       try {
//         const criteria = {
//           company: {
//             primaryId: companyId,
//           },
//         };

//         const discounts = await dispatch(findDiscountsByCriteria(criteria));
//       } catch (error) {
//       }
//     };

//     fetchDiscounts();
//   }, [dispatch, companyId]);

//   useEffect(() => {
//     const checkPendingBooking = async () => {
//       setIsCheckingPending(true);

//       const pendingBooking = sessionStorage.getItem("pendingBooking");

//       if (pendingBooking && isAuthenticated) {
//         setHasPendingBooking(true);
//         setIsProcessingGuestLogin(true);
//         await processPendingBooking(JSON.parse(pendingBooking));
//       } else {
//         setHasPendingBooking(false);
//         setIsCheckingPending(false);
//         setShowBookingInterface(true);
//       }
//     };

//     checkPendingBooking();
//   }, [isAuthenticated]);

//   const processPendingBooking = async (pendingData) => {
//     setIsProcessingPending(true);
//     try {
//       const { scheduledProductId, bookingData } = pendingData;
//       const bookingDuration = sessionStorage.getItem("bookingDuration") || bookingData.duration || 1;
//       const durationType = getDurationTypeForApi(bookingData.bookingType || bookingType);

//       const shoppingCartId = userAccount.account.shoppingCart?.primaryId || null;

//       // Updated payload structure matching the document
//       const shoppingCartPayload = {
//         primaryId: shoppingCartId,
//         accountId: userAccount.account.primaryId,
//         createdBy: "WEB_UI",
//         modifiedBy: "WEB_UI",
//         productList: [{
//           productQuantity: {
//             numberOfUnit: parseInt(bookingDuration),
//             durationType: durationType
//           },
//           product: {
//             primaryId: bookingData.product?.primaryId,
//             price: {
//               currency: bookingData.product?.price?.currency || "USD",
//               priceAmt: bookingData.product?.price?.priceAmt,
//               msrp: bookingData.product?.price?.msrp || null,
//               type: bookingData.product?.price?.type || "BASE",
//               priceDurationType: bookingData.product?.priceDurationType || product?.priceDurationType
//             },
//             priceDurationType: bookingData.product?.priceDurationType || product?.priceDurationType
//           },
//           scheduledProduct: {
//             primaryId: scheduledProductId,
//             product: {
//               primaryId: bookingData.product?.primaryId,
//               price: {
//                 currency: bookingData.product?.price?.currency || "USD",
//                 priceAmt: bookingData.product?.price?.priceAmt,
//                 msrp: bookingData.product?.price?.msrp || null,
//                 type: bookingData.product?.price?.type || "BASE",
//                 priceDurationType: bookingData.product?.priceDurationType || product?.priceDurationType
//               },
//               priceDurationType: bookingData.product?.priceDurationType || product?.priceDurationType
//             },
//             schedule: {
//               primaryId: scheduledProductId
//             }
//           },
//           eligibleDiscounts: eligibleDiscounts.map(discount => ({
//             primaryId: discount.primaryId
//           })),
//           discounts: bookingData.selectedDiscount ? [{
//             primaryId: bookingData.selectedDiscount.primaryId
//           }] : []
//         }],
//         company: {
//           primaryId: companyId
//         }
//       };

//       const response = await dispatch(addToShoppingCart(shoppingCartPayload));

//       if (response) {
//         addToCart(shoppingCartPayload);
//         sessionStorage.removeItem("pendingBooking");
//         setHasPendingBooking(false);
//         setIsProcessingGuestLogin(false);
//         navigate("/cart");
//       }
//     } catch (err) {
//       setHasPendingBooking(false);
//       setIsProcessingPending(false);
//       setIsProcessingGuestLogin(false);
//       setShowBookingInterface(true);
//     }
//   };

//   const getDurationTypeForApi = (bookingType) => {
//     switch (bookingType) {
//       case 'hourly': return 'HOUR';
//       case 'daily': return 'DAY';
//       case 'weekly': return 'WEEK';
//       case 'monthly': return 'MONTH';
//       default: return '';
//     }
//   };

//   const [allDiscounts, setAllDiscounts] = useState(true);

//   useEffect(() => {
//     const fetchEligibleDiscounts = async () => {
//       if (!showBookingInterface || isProcessingGuestLogin) return;

//       setAllDiscounts(true);
//       try {
//         const payload = {
//           associatedProducts: [
//             {
//               company: { primaryId: companyId }
//             },
//           ],
//           criteria: {
//             durationTypes: [getDurationTypeForApi(bookingType)],
//             userAttributes: [],
//             productAttributes: []
//           }
//         };

//         const response = await dispatch(findEligibleDiscounts(payload));
//         if (response) {
//           // handle response
//         }
//       } catch (error) {
//       } finally {
//         setAllDiscounts(false);
//       }
//     };

//     fetchEligibleDiscounts();
//   }, [companyId, dispatch, product?.primaryId, showBookingInterface, isProcessingGuestLogin]);

//   useEffect(() => {
//     const fetchEligibleDiscounts = async () => {
//       if (!product?.primaryId || !companyId || !showBookingInterface || isProcessingGuestLogin) return;

//       setIsFetchingDiscounts(true);
//       try {
//         const payload = {
//           associatedProducts: [
//             {
//               primaryId: product.primaryId,
//               company: { primaryId: companyId }
//             }
//           ],
//           criteria: {
//             durationTypes: [getDurationTypeForApi(bookingType)],
//             userAttributes: [],
//             productAttributes: []
//           }
//         };

//         const response = await dispatch(findEligibleDiscounts(payload));
//         if (response) {
//           setEligibleDiscounts(response);
//           if (response.length > 0) {
//             setSelectedDiscount(response[0]);
//           } else {
//             setSelectedDiscount(null);
//           }
//         }
//       } catch (error) {
//         setEligibleDiscounts([]);
//         setSelectedDiscount(null);
//       } finally {
//         setIsFetchingDiscounts(false);
//       }
//     };

//     fetchEligibleDiscounts();
//   }, [bookingType, duration, product?.primaryId, companyId, dispatch, showBookingInterface, isProcessingGuestLogin]);

//   const calculateEndDateTime = () => {
//     if (!selectedDate || !selectedTime) return { endDate: '', endTime: '' };

//     const startDateTime = moment(`${selectedDate} ${selectedTime}`, 'YYYY-MM-DD HH:mm');
//     let endDateTime;

//     switch (bookingType) {
//       case 'hourly':
//         endDateTime = startDateTime.clone().add(duration, 'hours');
//         break;
//       case 'daily':
//         if (duration === 1) {
//           endDateTime = startDateTime.clone().add(8, 'hours');
//         } else {
//           endDateTime = startDateTime.clone().add(duration - 1, 'days').add(8, 'hours');
//         }
//         break;
//       case 'weekly':
//         endDateTime = startDateTime.clone().add(duration, 'weeks').add(8, 'hours');
//         break;
//       case 'monthly':
//         endDateTime = startDateTime.clone().add(duration, 'months').add(8, 'hours');
//         break;
//       default:
//         endDateTime = startDateTime.clone().add(duration, 'hours');
//     }

//     return {
//       endDate: endDateTime.format('YYYY-MM-DD'),
//       endTime: endDateTime.format('HH:mm'),
//       endDateFormatted: endDateTime.format('MMM DD, YYYY'),
//       endTimeFormatted: endDateTime.format('hh:mm A')
//     };
//   };

//   const calculateEffectiveEndDate = () => {
//     if (!selectedDate || !selectedTime) return null;

//     const startDateTime = moment(`${selectedDate} ${selectedTime}`, 'YYYY-MM-DD HH:mm');
//     let effectiveEndDate;

//     switch (bookingType) {
//       case 'hourly':
//         effectiveEndDate = startDateTime.clone().add(duration, 'hours');
//         break;
//       case 'daily':
//         effectiveEndDate = startDateTime.clone().add(duration, 'days');
//         break;
//       case 'weekly':
//         effectiveEndDate = startDateTime.clone().add(duration, 'weeks');
//         break;
//       case 'monthly':
//         effectiveEndDate = startDateTime.clone().add(duration, 'months');
//         break;
//       default:
//         effectiveEndDate = startDateTime.clone().add(duration, 'hours');
//     }

//     return effectiveEndDate.format('YYYY-MM-DDTHH:mm:ss');
//   };

//   const endDateTime = calculateEndDateTime();

//   const handleDurationChange = (newDuration) => {
//     if (newDuration >= currentBookingType.minDuration && newDuration <= currentBookingType.maxDuration) {
//       setDuration(newDuration);
//       sessionStorage.setItem('bookingDuration', newDuration);
//     }
//   };

//   const handleBookingTypeChange = (typeId) => {
//     setBookingType(typeId);
//     const newType = filteredBookingTypes.find(type => type.id === typeId);
//     setDuration(newType.minDuration);
//     sessionStorage.setItem('bookingDuration', newType.minDuration);
//   };

//   const handleDateSelect = (day) => {
//     if (!day.isPast && day.isCurrentMonth && !isProcessingPending && !isCheckingPending && !isProcessingGuestLogin) {
//       setSelectedDate(day.date.format('YYYY-MM-DD'));
//     }
//   };

//   const handlePrevMonth = () => {
//     if (!isProcessingPending && !isCheckingPending && !isProcessingGuestLogin) {
//       setCurrentMonth(currentMonth.clone().subtract(1, 'month'));
//     }
//   };

//   const handleNextMonth = () => {
//     if (!isProcessingPending && !isCheckingPending && !isProcessingGuestLogin) {
//       setCurrentMonth(currentMonth.clone().add(1, 'month'));
//     }
//   };

//   const createScheduleAndProduct = async () => {
//     const companyPrimaryId = companyId;

//     const saveProductPayload = {
//       period: {
//         effectiveDate: {
//           effectiveStartDate: moment(selectedDate).startOf("day").valueOf(),
//           effectiveEndDate: calculateEffectiveEndDate(),
//         },
//         durationType: getDurationTypeForApi(bookingType),
//         duration: duration,
//       },
//       owners: [],
//       product: {
//         primaryId: product.primaryId,
//         type: product.type || null,
//       },
//       createdBy: "user",

//       hasSchedule: true,
//       status: "ACTIVE",
//       company: { primaryId: companyPrimaryId },
//       hasChild: false,
//       parentProductId: null,
//       associatedScheduledProducts: [],
//       name: product.name || "Scheduled Product",
//       clients: [],
//     };

//     const productResponse = await saveScheduledProduct(saveProductPayload);
//     localStorage.setItem("selectedSchedulePrimaryId", productResponse.primaryId);

//     return productResponse.primaryId;
//   };

//   const handleConfirmBooking = async () => {
//     setIsLoading(true);

//     try {
//       const scheduledProductId = await createScheduleAndProduct();

//       if (!isAuthenticated) {
//         const pendingBookingData = {
//           scheduledProductId,
//           bookingData: {
//             bookingType,
//             duration,
//             selectedDate,
//             selectedTime,
//             endDateTime,
//             product,
//             selectedDiscount
//           }
//         };

//         sessionStorage.setItem("pendingBooking", JSON.stringify(pendingBookingData));
//         setShowLoginDialog(true);
//         setIsLoading(false);
//         return;
//       }

//       await handleGoToCart();

//     } catch (error) {
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleGoToCart = async () => {
//     setIsLoading(true);
//     try {
//       const bookingDuration = sessionStorage.getItem("bookingDuration") || duration;
//       const durationType = getDurationTypeForApi(bookingType);
//       const scheduledProductId = localStorage.getItem("selectedSchedulePrimaryId");

//       const shoppingCartId = userAccount.account.shoppingCart?.primaryId || null;

//       // Updated payload structure matching the document
//       const shoppingCartPayload = {
//         primaryId: shoppingCartId,
//         accountId: userAccount.account.primaryId,
//         createdBy: "WEB_UI",
//         modifiedBy: "WEB_UI",
//         productList: [{
//           productQuantity: {
//             numberOfUnit: parseInt(bookingDuration),
//             durationType: durationType
//           },
//           product: {
//             primaryId: product?.primaryId,
//             price: {
//               currency: product?.price?.currency || "USD",
//               priceAmt: product?.price?.priceAmt,
//               msrp: product?.price?.msrp || null,
//               type: product?.price?.type || "BASE",
//               priceDurationType: product?.priceDurationType
//             },
//             priceDurationType: product?.priceDurationType
//           },
//           scheduledProduct: {
//             primaryId: scheduledProductId,
//             product: {
//               primaryId: product?.primaryId,
//               price: {
//                 currency: product?.price?.currency || "USD",
//                 priceAmt: product?.price?.priceAmt,
//                 msrp: product?.price?.msrp || null,
//                 type: product?.price?.type || "BASE",
//                 priceDurationType: product?.priceDurationType
//               },
//               priceDurationType: product?.priceDurationType
//             },
//             schedule: {
//               primaryId: scheduledProductId
//             }
//           },
//           eligibleDiscounts: eligibleDiscounts.map(discount => ({
//             primaryId: discount.primaryId
//           })),
//           discounts: selectedDiscount ? [{
//             primaryId: selectedDiscount.primaryId
//           }] : []
//         }],
//         company: {
//           primaryId: companyId
//         }
//       };

//       const response = await dispatch(addToShoppingCart(shoppingCartPayload));

//       if (response.primaryId) {
//         addToCart(shoppingCartPayload);
//         navigate("/cart");
//       }

//     } catch (err) {
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLoginRedirect = () => {
//     setShowLoginDialog(false);
//     navigate('/sign-in');
//   };

//   const isAnyLoadingState = isLoading || isProcessingPending || isFetchingDiscounts || isCheckingPending || isProcessingGuestLogin;

//   if (isCheckingPending || isProcessingPending || isProcessingGuestLogin) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center">
//         <div className="bg-white p-8 rounded-2xl shadow-lg flex flex-col items-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
//           <p className="text-lg font-medium text-gray-800">
//             {isProcessingGuestLogin
//               ? "Completing your booking..."
//               : isProcessingPending
//                 ? "Processing your booking..."
//                 : "Checking for pending bookings..."}
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 relative" id="booking-page">
//       {isAnyLoadingState && (
//         <>
//           <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-40" />
//           <div className="fixed inset-0 flex items-center justify-center z-50">
//             <div className="bg-white p-6 rounded-2xl shadow-xl flex flex-col items-center">
//               <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-500 mb-4" />
//               <p className="text-lg font-medium text-gray-800 text-center">
//                 {isFetchingDiscounts ? "Checking available discounts..." : "Confirming your booking..."}
//               </p>
//             </div>
//           </div>
//         </>
//       )}

//       <div className={`transition-all duration-300 ${isAnyLoadingState ? 'opacity-50' : 'opacity-100'}`}>
//         <div className="bg-white border-b border-gray-200 p-4 sticky top-0 z-30">
//           <div className="max-w-7xl mx-auto">
//             <h1 className="text-2xl font-bold text-gray-800 mb-1">
//               Book {product?.name || 'Service'}
//             </h1>
//             <p className="text-gray-600 text-sm">Choose your perfect time and duration</p>
//           </div>
//         </div>

//         <div className="max-w-7xl mx-auto p-4">
//           <OffersSection offers={mockOffers} />

//           <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
//             <div className="xl:col-span-3 space-y-6">
//               <div className="grid lg:grid-cols-2 gap-6">
//                 <div className="bg-white rounded-lg shadow-md p-6">
//                   <h3 className="text-lg font-semibold mb-4 flex items-center text-gray-800">
//                     <CalendarDays className="w-5 h-5 mr-2 text-blue-500" />
//                     Choose Plan
//                   </h3>

//                   {(isProcessingPending || isCheckingPending || isProcessingGuestLogin || !product?.price?.priceAmt) ? (
//                     <div className="space-y-3">
//                       {[1, 2].map((index) => (
//                         <div key={index} className="animate-pulse bg-gray-200 h-16 rounded-lg"></div>
//                       ))}
//                     </div>
//                   ) : (
//                     <>
//                       <div className="space-y-3">
//                         {filteredBookingTypes.map((type) => (
//                           <BookingTypeCard
//                             key={type.id}
//                             type={{ ...type, basePrice: product?.price?.priceAmt || 0 }}
//                             isSelected={bookingType === type.id}
//                             onClick={() => !isAnyLoadingState && handleBookingTypeChange(type.id)}
//                             disabled={isAnyLoadingState}
//                             compact={true}
//                           />
//                         ))}
//                       </div>

//                       {currentBookingType && (
//                         <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
//                           <div className="text-sm text-blue-800">
//                             <p className="font-medium">{currentBookingType.label}</p>
//                             <p className="text-blue-600">{currentBookingType.description}</p>
//                           </div>
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </div>

//                 <div className="bg-white rounded-lg shadow-md p-6">
//                   {(isProcessingPending || isCheckingPending || isProcessingGuestLogin || !product?.price?.priceAmt) ? (
//                     <div className="animate-pulse space-y-4">
//                       <div className="h-5 bg-gray-200 rounded w-24"></div>
//                       <div className="flex justify-center">
//                         <div className="w-32 h-16 bg-gray-200 rounded"></div>
//                       </div>
//                     </div>
//                   ) : (
//                     <DurationControl
//                       duration={duration}
//                       minDuration={currentBookingType.minDuration}
//                       maxDuration={currentBookingType.maxDuration}
//                       unit={currentBookingType.unit}
//                       onDurationChange={handleDurationChange}
//                       disabled={isAnyLoadingState}
//                       compact={true}
//                     />
//                   )}
//                 </div>
//               </div>

//               <div className="bg-white rounded-lg shadow-md p-6">
//                 <h3 className="text-lg font-semibold mb-4 text-gray-800">Select Date & Time</h3>

//                 {(isProcessingPending || isCheckingPending || isProcessingGuestLogin || !product?.price?.priceAmt) ? (
//                   <div className="grid lg:grid-cols-2 gap-6">
//                     <div className="animate-pulse space-y-4">
//                       <div className="h-6 bg-gray-200 rounded w-32"></div>
//                       <div className="grid grid-cols-7 gap-2">
//                         {[...Array(35)].map((_, i) => (
//                           <div key={i} className="aspect-square bg-gray-200 rounded"></div>
//                         ))}
//                       </div>
//                     </div>
//                     <div className="animate-pulse space-y-3">
//                       <div className="h-6 bg-gray-200 rounded w-32"></div>
//                       <div className="grid grid-cols-3 gap-2">
//                         {[...Array(9)].map((_, i) => (
//                           <div key={i} className="h-10 bg-gray-200 rounded"></div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="grid lg:grid-cols-2 gap-6">
//                     <CalendarView
//                       currentMonth={currentMonth}
//                       selectedDate={selectedDate}
//                       onDateSelect={handleDateSelect}
//                       onPrevMonth={handlePrevMonth}
//                       onNextMonth={handleNextMonth}
//                       disabled={isAnyLoadingState}
//                       compact={true}
//                     />

//                     {selectedDate && (
//                       <TimeSlotPicker
//                         selectedTime={selectedTime}
//                         onTimeSelect={setSelectedTime}
//                         selectedDate={selectedDate}
//                         onResetDate={() => setSelectedDate('')}
//                         disabled={isAnyLoadingState}
//                         compact={true}
//                       />
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {selectedDate && selectedTime && (
//               <div className="xl:col-span-1">
//                 <div className="sticky top-24">
//                   <OrderSummary
//                     product={product}
//                     duration={duration}
//                     bookingType={bookingType}
//                     selectedDate={selectedDate}
//                     selectedTime={selectedTime}
//                     endDateTime={endDateTime}
//                     onConfirmBooking={handleConfirmBooking}
//                     isLoading={isAnyLoadingState}
//                     bookingTypes={filteredBookingTypes}
//                     selectedDiscount={selectedDiscount}
//                     disabled={isAnyLoadingState}
//                     compact={true}
//                   />
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {showLoginDialog && (
//         <LoginDialog
//           onClose={() => setShowLoginDialog(false)}
//           onLogin={handleLoginRedirect}
//           message="Your booking has been saved! Please login to complete your purchase."
//         />
//       )}
//     </div>
//   );
// };

export const MeetingScheduler = () => {
  const slots = ['09:00 AM', '10:00 AM', '11:00 AM', '01:00 PM', '02:00 PM', '03:00 PM'];

  return (
    <section className="rounded-xl bg-white p-4 sm:p-6">
      <div className="mb-6">
        <p className="text-sm font-semibold uppercase tracking-wide text-blue-600">Workspace Schedule</p>
        <h2 className="mt-2 text-2xl font-bold text-slate-900">Choose a date and time</h2>
        <p className="mt-2 text-slate-600">
          Select an available workspace slot. Live availability will load when company scheduling data is connected.
        </p>
      </div>

      <div className="grid gap-4 lg:grid-cols-[0.9fr_1.1fr]">
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
          <div className="mb-4 flex items-center justify-between">
            <span className="font-semibold text-slate-800">Today</span>
            <span className="text-sm text-slate-500">Available slots</span>
          </div>
          <div className="grid grid-cols-7 gap-2 text-center text-sm">
            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
              <span key={day} className="font-semibold text-slate-500">{day}</span>
            ))}
            {Array.from({ length: 28 }, (_, index) => (
              <button
                key={index}
                type="button"
                className={`aspect-square rounded-lg border text-sm font-semibold transition ${
                  index === 10
                    ? 'border-blue-600 bg-blue-600 text-white'
                    : 'border-slate-200 bg-white text-slate-700 hover:border-blue-300'
                }`}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <div className="mb-4">
            <h3 className="font-semibold text-slate-900">Available Times</h3>
            <p className="text-sm text-slate-500">Pick a start time for your reservation.</p>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            {slots.map((slot, index) => (
              <button
                key={slot}
                type="button"
                className={`rounded-lg border px-4 py-3 text-left font-semibold transition ${
                  index === 1
                    ? 'border-blue-600 bg-blue-50 text-blue-700'
                    : 'border-slate-200 text-slate-700 hover:border-blue-300 hover:bg-blue-50'
                }`}
              >
                {slot}
              </button>
            ))}
          </div>
          <button
            type="button"
            className="mt-6 w-full rounded-lg bg-blue-600 px-5 py-3 font-semibold text-white transition hover:bg-blue-700"
          >
            Continue Booking
          </button>
        </div>
      </div>
    </section>
  );
};
